<template>
	<div class="page-content">
		<div class="inner-content">
			<div class="main-title">
				<p class="title dark_pink_text"><span class="no dark_pink_bg">{{ index + 1 }}</span>Le projet urbain et ses conséquences sur l'attractivité à terme du programme étudié</p>
			</div>

            <section-projet-urbain />

			<div class="main-title" style="margin-bottom: 6px;">
				<p class="title dark_orange_text"><span class="no dark_orange_bg">{{ index + 2 }}</span>Approche quantitative des besoins pour le locatif intermédiaire au sein du projet urbain</p>
			</div>
            <section-approche-quantitative />
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";


import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import SectionProjetUrbain from "./sections/section-projet-urbain.vue";
import SectionApprocheQuantitative from "./sections/section-approche-quantitative.vue";

export default {
	name: "page-marches",
	mixins: [ PageMixin ],
	data: function () {
		return {
			form: {
				
			}
		};
	},
	props: [ "index" ],
	computed: {
		...mapGetters([ "active_study" ]),
	},
	components: {
		SectionProjetUrbain,
		SectionApprocheQuantitative
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

</style>
